export default __webpack_public_path__ + "static/media/access_time_green.5995e4ae.svg";